import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { WalletProvider } from './context/WalletContext';
import Navigation from './components/Navigation';
import Mindshare from './pages/Mindshare';
import Profile from './pages/Profile';

// Layout component to conditionally show Navigation
const Layout = ({ children }) => {
  const location = useLocation();
  // Hide global navigation on Mindshare page (it has its own)
  const hiddenNavPaths = ['/', '/mindshare'];
  const showNav = !hiddenNavPaths.includes(location.pathname);

  return (
    <div className="min-h-screen" style={{ background: '#0A1628' }}>
      {children}
    </div>
  );
};

function App() {
  useEffect(() => {
    // Extract ref query parameter and store in localStorage
    const searchParams = new URLSearchParams(window.location.search);
    const refCodeRaw = searchParams.get('ref');

    if (refCodeRaw) {
      const refCode = String(refCodeRaw).trim();
      const isValidReferralCode = /^[A-Za-z0-9]{8}$/.test(refCode);

      if (isValidReferralCode) {
        localStorage.setItem('referralCode', refCode);
      }

      // Clean up URL to avoid confusion / repeated parsing
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return (
    <WalletProvider>
      <Router>
        <Layout>
          <Routes>
            {/* Mindshare as landing page */}
            <Route path="/" element={<Mindshare />} />
            <Route path="/mindshare" element={<Mindshare />} />

            <Route path="/profile" element={<Profile />} />
          </Routes>
        </Layout>
      </Router>
    </WalletProvider>
  );
}

export default App;
